import {baseRequestService} from "../base.ts";
import {User} from "../../types/domain.ts";

export const authGet = () => baseRequestService<User>({
    url: '/auth',
    method: 'GET',
})